
interface PaywallTimelineStepProps {
    title: string;
    description: string;
    isFirstStep?: boolean;
    isLastStep?: boolean;
    icon: React.ReactNode;
}

export const PaywallTimelineStep = ({ title, description, isFirstStep = false, isLastStep = false, icon }: PaywallTimelineStepProps) => {

    const getIconColors = () => {
        if (isFirstStep) {
            return 'bg-osGrey-1 text-white';
        }
        return 'bg-osGrey-4 text-osBlack';
    }

    return (
        <div className='flex flex-row items-stretch justify-center gap-3 h-[82px]'>
            <div className='relative'>
                <div id="icon" className={`relative w-[36px] h-[36px] rounded-full flex items-center justify-center z-[2] ${getIconColors()}`}>
                    {icon}
                </div>
                <div id="track" className='absolute w-[18px] h-full top-0 left-1/2 -translate-x-1/2 z-[1]'>
                    <div className={`absolute top-0 left-0 w-[18px] ${isLastStep ? 'h-[25%]' : 'h-full'} bg-osGrey-4 z-[0]`}></div>
                    {isFirstStep && <div className='absolute top-0 left-0 w-[18px] h-[75%] bg-osGrey-1 rounded-full z-[1]'></div>}
                </div>
            </div>
            <div className='flex flex-col text-left'>
                <h3 className='text-osBlack text-[20px] font-semibold'>{title}</h3>
                <p className='text-osGrey-2 text-sm'>
                    {description}
                </p>
            </div>
        </div>
    );
};